export default value => !RegExp(/(.)\1{2}/).test(value);
